import {
  useMutation,
  useQueryClient,
  type UseMutationResult,
} from '@tanstack/react-query';
import { candidatesApi } from '../candidatesApi';
import type { Candidate, UpdateCandidateStatusRequest } from '../../types';
import type { TFormErrorResponse } from '@shared/types';
import type { AxiosError } from 'axios';
import { candidateMutationKeys, candidateQueryKeys } from '../queryKeys';

export const useUpdateCandidateStatus = (
  candidateId: string | number
): UseMutationResult<
  Candidate,
  AxiosError<TFormErrorResponse>,
  UpdateCandidateStatusRequest
> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [...candidateMutationKeys.updateStatus, candidateId],
    mutationFn: request =>
      candidatesApi.updateCandidateStatus(candidateId, request),
    onSuccess: async candidate => {
      queryClient.setQueryData(
        candidateQueryKeys.detail(candidateId),
        candidate
      );
      await queryClient.invalidateQueries({
        queryKey: candidateQueryKeys.lists(),
      });
    },
  });
};
